module.exports = __webpack_public_path__ + "img/kemanStore-appSecret.1481967e.png";